import { EMISSION_COLORS } from "../../../../../MapV2/constants";

export const Legend = () => (
    <div className="flex flex-col gap-0.5">
        <p className="text-neutral-500">Sources</p>
        <div className="flex items-center gap-2">
            <div
                className="h-3 w-3 rounded-full flex-shrink-0"
                style={{
                    backgroundColor: `rgb(${EMISSION_COLORS.operatorProvided})`,
                }}
            />
            Company Monitoring Data
        </div>
        <div className="flex items-center gap-2">
            <div
                className="h-3 w-3 rounded-full flex-shrink-0"
                style={{
                    backgroundColor: `rgb(${EMISSION_COLORS.thirdParty})`,
                }}
            />
            3rd Party Detections
        </div>
        <p className="text-neutral-500 mt-2">Type and status</p>
        <div className="flex items-center gap-2">
            <svg
                aria-label="icon with strokes on infill"
                className="h-3 w-3 flex-shrink-0"
                viewBox="0 0 12 12"
            >
                <defs>
                    <pattern
                        id="stripePattern-thirdParty"
                        patternUnits="userSpaceOnUse"
                        width="4"
                        height="4"
                    >
                        <rect width="4" height="4" fill="white" />
                        <path
                            d="M-1,1 l2,-2 M0,4 l4,-4 M3,5 l2,-2"
                            stroke="gray"
                            strokeWidth="1"
                        />
                    </pattern>
                </defs>
                <circle
                    cx="6"
                    cy="6"
                    r="5"
                    fill={`url(#stripePattern-thirdParty)`}
                    stroke="gray"
                    strokeWidth="1"
                />
            </svg>
            Pending site confirmation
        </div>

        <div className="flex items-center gap-2">
            <svg
                aria-label="icon with dashed outline"
                className="h-3 w-3 flex-shrink-0"
                viewBox="0 0 12 12"
            >
                <circle
                    cx="6"
                    cy="6"
                    r="5"
                    stroke="gray"
                    strokeWidth="2"
                    strokeDasharray="3,3"
                    fill="white"
                />
            </svg>
            Grouped site totals
        </div>

        <div className="flex items-center gap-2">
            <svg
                aria-label="icon with rounded bar"
                className="h-3 w-3 flex-shrink-0"
                viewBox="0 0 12 12"
            >
                <rect
                    x="0"
                    y="3"
                    width="12"
                    height="6"
                    rx="3"
                    ry="3"
                    fill="gray"
                />
            </svg>
            24h averages
        </div>

        <div className="flex items-center gap-2">
            <svg
                aria-label="icon with dashed outline"
                className="h-3 w-3 flex-shrink-0"
                viewBox="0 0 12 12"
            >
                <rect x="0" y="0" width="12" height="12" fill="#4096FF88" />
            </svg>
            Site non-detects
        </div>
    </div>
);
